<template>
<div class="style" v-show="judge" :style="{ 'z-index': modaldata.Zindex, }" @click="stopDocument($event)">
  <div class="closeModal" @click="saveStyle(selectStyle); closeModal()"></div>
  <div
    class="styleBody"
    :style="{
      'width'  : styleDatas.length * 218 + 'px',
      'height' : Window_Size.height > 768 ? '607px' : '350px',
      'minWidth': '640px'
    }">
    <div
      class="styleLead"
      v-show="styleDatas[0] && styleDatas[0].judge"
    >
      Hi @{{ UserMsg.nickname || '亲爱的画伴'}},   请选择素材风格
      <span class="lead">
        (选择相应的风格后，场景页/背景/角色/文字/道具/形状等素材将会切换为对应风格的素材)
      </span>
    </div>

    <div class="styleMsg">
      <div v-for="(item, index) in styleDatas">
        <transition v-on:enter="enter($event, index)" v-on:leave="leave($event, index)" :css="false">
          <div v-show="judge">
          <transition name="slide-styleMsg">
            <div
              v-show="item.judge"
              @click="
                saveStyle(item);
                materialPushAnalysis({type: 'style', id: item.id, name: item.name});
                closeModal();
              "
              @mouseenter="hoverStyle(item, index);"
              :class="{
                'active': item.id === selectStyle.id,
              }"
            >
              <img :src="$handleAssetsUrl(item.thumbnailUrl)" width="100%" height="100%">
              <span>
                {{item.name || 'null'}}
              </span>
            </div>
            </transition>
          </div>
        </transition>
      </div>
    </div>

    <transition name="slide-styleMsg">
    <div
      class="styleMsgBody"
      v-if="styleDatas.length && styleDatas[styleDatas.length-1].judge && Window_Size.height > 768"
    >
      <span class="Triangle" :style="{'left': TriangleLeft + 'px'}" ></span>
      <div v-for="(item, index) in styleMsgBody">
        <transition name="slide-styleMsg">
          <div  v-show="item.judge">
            <img :src="$handleAssetsUrl(item.url)" width="100%" height="100%">
          </div>
        </transition>
      </div>
    </div>
    </transition>
  </div>
  <!-- <div class="popover-box" v-show="isFirstUse" :style="{top: top, left: left}">
    选择一个风格后，场景页、背景、道具、形状均会切换至相应的风格
    <div class="right-arrow"></div>
  </div> -->
</div>
</template>

<script>
//  弹窗组件，所欲设置的弹窗组件
import { mapGetters } from 'vuex'
import modal    from '../mixins/modal'
import judgevipComponents from '../mixins/judgeVip/judgeVipEvent.vue'; // 会员判断函数
import Velocity from 'velocity-animate'
import Analysis from '../mixins/analysis/materialBu'


export default {
  mixins: [modal, Analysis, judgevipComponents],
  data() {
    return {
      styleDatas   : [],
      styleMsgBody : [],
      styleMsgBodyAnime : false,
      modalName   : 'style',
      selectStyle : null,
      isFirstUse: false,
      top: '',
      left: '',
      judgeAnime : false,
      timeoutid : null,
      TriangleLeft : 90,
      projectStyle : false,
      apiNum       : 5,
    };
  },
  // props: ['dataMsg'],
  computed: {
    ...mapGetters([
			'WorksTemplateStyle'
    ])
	},
  watch : {
    'boxData' : function(val, oldval){ // 判断打开关闭
      if (this.judge ) { // 打开的操作
        if(!this.styleDatas.length && this.apiNum != 0){
          this.apiNum--;
          this.$http.get('/api/home/style').then((res) => { // 请求风格数据

            let data = res.data.data;
            for(let item in data){
              let itemData = {
                id           : data[item].id,
                name         : data[item].name,
                overview     : data[item].overview ? data[item].overview.split(",") : [],
                thumbnailUrl : data[item].thumbnailUrl,
                iconUrl      : data[item].iconUrl ? data[item].iconUrl.split(",")[1] : '',
                judge        : false,
                data         : data[item],
              }
              if(item < 1){
                this.selectStyleFs(itemData, 0);
              }
              this.styleDatas.push(itemData);
              itemData = null;
            }
            this.$store.commit('toggle_StyleArrayMsg', { // 切换style详细数据
              styleArray : this.styleDatas,
            });
            // console.log('this.styleDatas', this.styleDatas);
            this.closeModal();
          }).then(() => {
            if(this.projectStyle){
              this.saveStyle(this.selectStyle)
              this.closeModal()
              return;
            }
            this.judgeStyleFs();
            this.$bus.emit('Modal_vue', {name : 'style'});
            this.$bus.emit('setTemplateStyle');
          });
        }
      }
    },
    'styleMsgBodyAnime' : function(val, oldval){ // 判断打开关闭
      if(this.styleMsgBodyAnime ) { // 打开的操作
        let index = 0;
        let setIntervalTime = setInterval(() => {
          if(this.styleMsgBody[index]){
            this.styleMsgBody[index].judge = true;
          }
          index++
          if(index > this.styleMsgBody.length-1){
            this.judgeAnime = true;
            clearInterval(setIntervalTime);
          }
        }, 50);
      }else{
        let index = 0;
        let setIntervalTime = setInterval(() => {
          if(this.styleMsgBody[index]){
            this.styleMsgBody[index].judge = false;
          }
          index++
          if(index > this.styleMsgBody.length-1){
            clearInterval(setIntervalTime);
          }
        }, 50);
      }
    },
    judge(val, oldval) {
      // 关闭新手引导页
      if(this.judge && this.selectStyle && this.StyleMsg==='null'){ // 判断路由隐藏风格选择页面
        this.judgeStyleFs();
      }
      // if(val){
      //   this.judgeVip_worksDraftNum();
      // }
    },
    'judgeAnime' : function(val, oldval){ // 判断打开关闭
      if(this.judgeAnime){
        for(let i = 0; i < this.styleMsgBody.length; i++){
          this.styleMsgBody[i].judge = true;
        }
        this.judgeAnime = false;
      }
    },
  },
  mounted () {
    // 打开新手引导页
    this.$bus.on('showGuidanceStyle', () => {
      this.isFirstUse = true;
      let styleBody = document.getElementsByClassName('styleBody')[0];
      let firstChild = styleBody.children[0].children[0];
      let bodyStyle = window.getComputedStyle(styleBody, null);
      let firstChildStyle = window.getComputedStyle(firstChild, null);
      this.top = (parseFloat(bodyStyle.marginTop) + parseFloat(firstChildStyle.height) / 2 - 52) + 'px';
      this.left = (parseFloat(bodyStyle.marginLeft) - 180) + 'px';
    });

    this.$bus.on('projectStyle', (data) => { // 主动关闭弹窗
      if(data.type){
        if(this.selectStyle){
          this.saveStyle(this.selectStyle)
          this.closeModal()
        }else{
          this.projectStyle = true;
        }
      }
    });
  },
  methods: {
    saveStyle(data){    // 保存风格\
      if(this.StyleMsg === 'null'){
        this.materialPushAnalysis({type: 'style', id: this.styleDatas[0].id, name: this.styleDatas[0].name})
      }
      this.selectStyle = data || this.styleDatas[0];
      this.$store.commit('toggle_StyleDataMsg', { // 切换style详细数据
        id : data.id,
      });
      // 新手指引
      if (window.localStorage.getItem('used')) return;
      this.isFirstUse = false;
      this.$bus.emit('showGuidanceAddScence');
    },
    enter: function (el, index) { // 打开动画
      Velocity(el, { }, {});
      Velocity(el, { }, { duration:  (index*100), complete: ()=>{
        this.styleDatas[index].judge = true;
        if(this.styleDatas[this.styleDatas.length-1].judge){
          this.styleMsgBodyAnime = true;  // 小图动画
        }
      },});
    },
    leave: function (el, index) { // 关闭动画
      Velocity(el, { }, { duration: (index*100), complete: ()=>{
        this.styleDatas[index].judge = false;
        this.styleMsgBodyAnime = false;  // 小图动画
      },});
    },
    hoverStyle(data, index){
      if(this.selectStyle.id != data.id){
        this.styleMsgBodyAnime = false;  // 小图动画
        if(this.timeoutid){
          clearTimeout(this.timeoutid);
        }
        this.timeoutid = setTimeout(() => {
          this.selectStyleFs(data, index)
          clearTimeout(this.timeoutid);
        }, 300);
      }
    },
    selectStyleFs(data, index){
      this.TriangleLeft = index * 225 + 90;
      this.selectStyle = data;
      this.styleMsgBody = [];
      if(this.selectStyle.overview && this.selectStyle.overview.length){
        for(let i = 0, ilen = this.selectStyle.overview.length; i < ilen; i++) {
          let data = {
            url   :  this.selectStyle.overview[i],
            judge : false,
          }
          this.styleMsgBody.push(data)
        }
      }else{
        this.styleMsgBody = [];
      }
      this.styleMsgBodyAnime = true;  // 小图动画
    },
    judgeStyleFs(){
      let routerArray = Object.keys(this.$route),
          routerData = this.$route,
          routerjudge = false;
      if(routerArray.length && this.styleDatas.length){
        if('style' in routerData){
          for(let i = 0; i < this.styleDatas.length; i++){
            if(this.styleDatas[i] && routerData.style == this.styleDatas[i].id){
              this.selectStyle = this.styleDatas[i];
              routerjudge = true;
              break;
            }
          }
        }
        if(!routerjudge){
          let id = this.WorksTemplateStyle;
          let f = (this.styleDatas.filter((v) => id === v.id) || [])[0];
          this.selectStyle = f || this.styleDatas[0];
        }
        // console.log(this.selectStyle, '<-判断路由隐藏风格选择页面')
        this.saveStyle(this.selectStyle)
        this.closeModal()
      }
    },
  },
  components: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .style{
    background: rgba(255, 255, 255, 0.90);

    >div{
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      margin: auto;
    }

    .closeModal{
      width: 21px;
      height: 21px;
      margin: 0;
      left: initial;
      top: 28px;
      right: 32px;
      line-height: 50px;
      cursor: pointer;
      background: url('../../../static/svg/close.svg') no-repeat center;
    }

    .styleBody{
      height: 607px;

      .styleLead{
        position: absolute;
        top: -80px;
        left: 0;
        width: 100%;
        height: 60px;
        text-align: left;
        font-size: 20px;
        font-weight: 600;
        color: #554f6e;

        .lead{
          position: absolute;
          bottom: 0;
          left: 0;
          font-size: 14px;
          font-weight: 300;
        }
      }

      .styleMsg{
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 350px;

        >div{
          width: 186px;
          height: 330px;
          transition: all 0.3s;
          cursor: pointer;

          >div{
            width: 100%;
            height: 100%;

            >div{
              position: relative;
              background: #fff;
              -webkit-box-shadow:0 0 8px #a5abab;
              -moz-box-shadow:0 0 8px #a5abab;
              box-shadow:0 0 8px #a5abab;
              border-radius: 10px;
              width: 100%;
              height: 100%;
              overflow: hidden;
              -webkit-transform: scale(1);
              -moz-transform: scale(1);
              transform: scale(1);
              transition: all 0.3s;

              >img{
                width: 100%;
                height: 100%;
                max-width: 100%;
                max-height: 100%;
              }
              span{
                position: absolute;
                left: 0;
                right: 0;
                bottom: 40px;
                margin: auto;
                width: 100%;
                height: 18px;

              }
            }
            .active{
              box-shadow: 0 0 25px #a5abab;
              -webkit-transform: scale(1.01);
              -moz-transform: scale(1.01);
              transform: scale(1.01);
            }
          }
        }
      }
      .styleMsgBody{
        display: flex;
        justify-content: space-around;
        align-items: center;
        position: absolute;
        bottom: 70px;
        left: 0;
        width: 100%;
        height: 160px;
        border-top: 2px solid #d6d3d3;

        .Triangle{
          content: '';
          position: absolute;
          top: -2px;
          left: 0;
          right: 0;
          width: 0px;
          height: 0px;
          border: 10px solid transparent;
          border-top: 12px solid #797979;
          transition: all 0.3s;
        }

        div{
          width: 180px;
          height: 108px;
          >img{
            width:100%;
            height:100%;
            border-radius: 5px;

          }
        }
      }
    }
    .popover-box{
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 20px;
      top: 58px;
      left: 212px;
      height: 100px;
      z-index: 2001;
      margin: 0;
      background: #000;
      opacity: .6;
      width: 170px;
      height: 104px;
      color: #fff;
      line-height: 1.4;
      text-align: justify;
      font-size: 14px;
      border-radius: 8px;
      .right-arrow {
        position: absolute;
        display: block;
        width: 0;
        height: 0;
        border-color: transparent;
        border-style: solid;
        top: 47px;
        right: -6px;
        margin-bottom: 3px;
        border-width: 6px;
        border-right-width: 0;
        border-left-color:#000;
      }
    }
  }

  .slide-styleMsg-enter-active {
    transition: all .3s ease;
  }
  .slide-styleMsg-leave-active {
    transition: all .3s ease-in;
  }
  .slide-styleMsg-enter, .slide-styleMsg-leave-to
  /* .slide-styleMsg-leave-active for below version 2.1.8 */ {
    transform: translateY(1000px);
    opacity: 0;
  }


</style>



// WEBPACK FOOTER //
// src/components/modal/style.vue